import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConstantsService } from '../constant/constants.service';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { GenericCrudService } from '../generic-crud.service';
import { HttpHeaders } from '@angular/common/http';
import { Prestation } from 'src/app/shared/models/prestation';

@Injectable({
	providedIn: 'root'
})
export class SituationPrestationService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	getAllSituationPrestation(): Observable<Prestation[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.situationPrestationUrl}/all`,
			'getAllSituationPrestation'
		);
	}


	getSituationPrestationById(id: number): Observable<Prestation> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.situationPrestationUrl}/get/${id}`,
			'getSituationPrestationById'
		);
	}

	updateSituationPrestation(situationPrestation: Prestation): Observable<void> {
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.situationPrestationUrl}/update/${situationPrestation.id}`,
			'updateSituationPrestation',
			situationPrestation
		);
	}

	addSituationPrestation(situationPrestation: Prestation): Observable<void> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.situationPrestationUrl}/add`,
			'addSituationPrestation',
			situationPrestation
		);
	}

	deleteSituationPrestation(situationPrestationId: number): Observable<void> {
		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.appConstants.situationPrestationUrl}/delete/${situationPrestationId}`,
			`deleteSituationPrestation`
		);
	}

}
